<template>
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9.9375 4.93744C9.9375 5.45521 9.51777 5.87494 9 5.87494C8.48223 5.87494 8.0625 5.45521 8.0625 4.93744C8.0625 4.41968 8.48223 3.99994 9 3.99994C9.51777 3.99994 9.9375 4.41968 9.9375 4.93744Z"
            class="fill-current" />
        <path
            d="M9 7.2519C8.65482 7.2519 8.375 7.53172 8.375 7.8769V13.3769C8.375 13.7221 8.65482 14.0019 9 14.0019C9.34518 14.0019 9.625 13.7221 9.625 13.3769V7.8769C9.625 7.53172 9.34518 7.2519 9 7.2519Z"
            class="fill-current" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.25 9C0.25 13.8325 4.16751 17.75 9 17.75C11.3206 17.75 13.5462 16.8281 15.1872 15.1872C16.8281 13.5462 17.75 11.3206 17.75 9C17.75 4.16751 13.8325 0.25 9 0.25C4.16751 0.25 0.25 4.16751 0.25 9ZM1.5 9.00092C1.5 13.1431 4.85786 16.5009 9 16.5009C10.9891 16.5009 12.8968 15.7107 14.3033 14.3042C15.7098 12.8977 16.5 10.99 16.5 9.00092C16.5 4.85878 13.1421 1.50092 9 1.50092C4.85786 1.50092 1.5 4.85878 1.5 9.00092Z"
            class="fill-current" />
    </svg>
</template>
